import { PREFIX } from '../../constants';

const generateMaskStyle = ({ controlName, attributes }) => {
    const {
        [`${PREFIX}${controlName}MaskShape`]: maskShape,
        [`${PREFIX}${controlName}MaskSize`]: maskSize,
        [`${PREFIX}${controlName}MaskPosition`]: maskPosition,
        [`${PREFIX}${controlName}MaskRepeat`]: maskRepeat
    } = attributes;

    let maskStyle = '';
    if (maskShape !== 'none' && maskShape !== undefined) {
        maskStyle = `
            mask-image: url(${faqmateGLocalize?.maskShapes[maskShape]});
            mask-size: ${maskSize};
            mask-position: ${maskPosition};
            mask-repeat: ${maskRepeat};
        `;
    }

    return {
        maskStyle
    };
};

export default generateMaskStyle;
